import styled from "styled-components";
import { theme } from "../theme";

export const StyledPageHeader = styled.div`
	margin-top: ${(props) => (props.marginTop ? "3rem" : "0")};
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;

	& h1 {
		margin: 0;
	}

	& h2 {
		font-size: 2.5rem;
		font-weight: 900;
	}

	& h4 {
		font-size: 2.5rem;
		font-weight: 900;
		margin-bottom: 1.5rem;
	}

	& div {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		opacity: 0.6;

		& i {
			width: min-content;
			height: min-content;
			display: flex;
			margin-right: 0.75rem;
		}

		& > button {
			& span {
				white-space: nowrap;
				display: block;
			}
		}

		& form {
			width: 40rem;
		}

		& span {
			height: min-content;
			font-size: 1.2rem;
			font-weight: 500;
			line-height: 1rem;
			font-family: ${theme.font.secondary};

			display: block;

			&:first-child {
				margin-right: 0.75rem;
			}
		}
	}
`;
